import React from 'react';
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
  Link,
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  box: {
    boxShadow:
      '0px 2px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: '0 !important',
    backgroundColor: '#FFF',

    '@media(min-width: 768px)': {
      padding: 24,
      marginBottom: theme.spacing(3),
    },
  },
  boxTitle: {
    fontSize: '1.2rem',
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: `1px solid ${theme.palette.action.focus}`,
  },
  inlineButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: 'auto',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',
    position: 'relative',
    paddingRight: 30,

    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'inline-block',
      borderRight: '2px solid blue',
      borderBottom: '2px solid blue',
      width: 6,
      height: 6,
      left: 'calc(100% - 20px)',
      top: 9,
      transform: 'rotate(45deg) translateY(-5px)',
      transition: 'all .2s',
    },
  },
  hide: {
    '&:after': {
      top: 4,
      left: 'calc(100% - 16px)',
      transform: 'rotate(-135deg) translateY(-5px)',
    },
  },
  list: {
    padding: 16,
  },
  listItem: {
    padding: 0,
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },
  listText: {
    marginTop: 0,
    marginLeft: 16,
    fontSize: 16,
  },
  listFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  forceh5: {
    fontSize: '1.5rem',
    fontWeight: 400,
  },
}));

const FaQ = ({ fileAddress }) => {
  const [showFaQ, setShowFaQ] = React.useState(false);
  const classes = useStyles();

  const handleShowFaQ = () => {
    setShowFaQ(!showFaQ);
  };

  return (
    <Box className={classes.box}>
      <Grid item xs={12} className={classes.listHeader}>
        <Typography className={classes.boxTitle}>
          Informacje o głosowaniu
        </Typography>
        <span
          className={
            showFaQ
              ? clsx(classes.inlineButton, classes.hide)
              : classes.inlineButton
          }
          onClick={handleShowFaQ}
          role='button'
          tabindex='0'
          aria-label={showFaQ ? 'Zwiń' : 'Rozwiń'}
        >
          {showFaQ ? 'Zwiń' : 'Rozwiń'}
        </span>
      </Grid>
      {showFaQ && (
        <Grid item xs={12} className={classes.list}>
          <Typography variant='h1' className={classes.forceh5}>
            <strong>Jak głosować?</strong>
          </Typography>
          <List dense={false}>
            <ListItem className={classes.listItem}>
              <span>1.</span>
              <ListItemText
                className={classes.listText}
                primary='Wyboru projektów dokonują w głosowaniu osobiście mieszkańcy i mieszkanki Miasta figurujący na liście osób uprawnionych do głosowania w BO. Lista tworzona jest na podstawie:
a) listy osób figurujących na liście osób uprawnionych do głosowania w BO w roku poprzednim;
b) listy osób zameldowanych na pobyt stały w Mieście.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>2.</span>
              <ListItemText
                className={classes.listText}
                primary={
                  <Typography>
                    Mieszkańcy i mieszkanki Miasta nie figurujący na liście osób
                    uprawnionych do głosowania w BO, mogą dopisać się do niej
                    poprzez złożenie wypełnionej papierowej karty do głosowania
                    w jednym z Biur Obsługi Mieszkańców lub filii Miejskiej
                    Biblioteki Publicznej. Jej wzór można pobrać{' '}
                    <Link target='_blank' rel='noopener' href={fileAddress}>
                      TUTAJ
                    </Link>
                    .
                  </Typography>
                }
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>3.</span>
              <ListItemText
                className={classes.listText}
                primary='Oświadczenie można złożyć osobiście w Urzędzie Miasta Lublin w terminie do 31 sierpnia każdego roku lub w trakcie głosowania wyłącznie wraz z papierową kartą do głosowania w wyznaczonych punktach.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>4.</span>
              <ListItemText
                className={classes.listText}
                primary='Listę punktów do głosowania podaje się do publicznej wiadomości, w szczególności na stronie internetowej Urzędu Miasta Lublin.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>5.</span>
              <ListItemText
                className={classes.listText}
                primary='Nie dopuszcza się możliwości wyznaczenia punktu do głosowania na nieruchomości objętej projektem poddanym pod głosowanie mieszkańców. Nie dotyczy to siedziby Urzędu Miasta Lublin, jego komórek organizacyjnych i jednostek organizacyjnych Miasta.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>6.</span>
              <ListItemText
                className={classes.listText}
                primary='W punktach do głosowania, o których mowa w pkt. 4, można otrzymać karty do głosowania oraz skrócone opisy projektów poddanych pod głosowanie.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>7.</span>
              <ListItemText
                className={classes.listText}
                primary={
                  <Typography>
                    Wzór karty do głosowania można pobrać{' '}
                    <Link target='_blank' rel='noopener' href={fileAddress}>
                      TUTAJ
                    </Link>
                    .
                  </Typography>
                }
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>8.</span>
              <ListItemText
                className={classes.listText}
                primary='Głosowanie, o którym mowa w pkt. 1-3, przeprowadza się poprzez:
a) osobiste złożenie karty do głosowania w wyznaczonych punktach do głosowania;
b) osobiste wypełnienie elektronicznej wersji karty do głosowania dostępnej na stronie internetowej Urzędu Miasta Lublin, po uprzedniej rejestracji z użyciem jako potwierdzenia numeru telefonu komórkowego lub adresu e-mail. Maksymalna ilość rejestracji z użyciem jednego numeru telefonu komórkowego lub adresu e-mail wynosi 5.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>9.</span>
              <ListItemText
                className={classes.listText}
                primary='W przypadku osób, które mają trudności z poruszaniem się, możliwe jest oddanie głosu poprzez przekazanie karty do głosowania osobie reprezentującej Urząd Miasta Lublin, w miejscu zamieszkania osoby głosującej na terenie Miasta Lublin, po uprzednim zawiadomieniu o takiej potrzebie Biura Partycypacji Społecznej Urzędu Miasta Lublin, nie później niż na 3 dni przed terminem rozpoczęcia głosowania.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>10.</span>
              <ListItemText
                className={classes.listText}
                primary='Mieszkaniec na karcie lub elektronicznym systemie do głosowania musi podać imię, nazwisko, 4 ostatnie cyfry z nr PESEL lub 4 ostatnie cyfry z innego dokumentu tożsamości, a na karcie papierowej złożyć własnoręczny podpis.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>11.</span>
              <ListItemText
                className={classes.listText}
                primary='Głosowanie organizuje się po opublikowaniu ostatecznej listy projektów, o której mowa w § 13 uchwały i trwa minimum 14 dni.'
              />
            </ListItem>
            <ListItem className={classes.listItem}>
              <span>12.</span>
              <ListItemText
                className={classes.listText}
                primary='Osoby głosujące na kartach do głosowania dokonują wyboru maksymalnie 2 projektów dzielnicowych i maksymalnie 2 projektów ogólnomiejskich.'
              />
            </ListItem>
          </List>
          <Grid item xs={12} className={classes.listFooter}>
            <span
              className={clsx(classes.inlineButton, classes.hide)}
              onClick={handleShowFaQ}
              role='button'
              tabindex='0'
              aria-label='Zwiń'
            >
              Zwiń
            </span>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

FaQ.propTypes = {
  fileAddress: PropTypes.string.isRequired,
};

export default FaQ;
